import type { JSX } from 'react';
import { useSearchParams } from 'react-router-dom';

const REASON_COPY: Record<string, string> = {
  user_cancelled:
    'You cancelled the payment. No charge has been made.',
  toss_failure:
    'Toss could not complete the payment. Your card has not been charged.',
  confirm_rejected:
    'The payment could not be verified. Please try again or contact support.',
  provider_unavailable:
    'The payment provider is temporarily unavailable. Please try again in a moment.',
  already_processed:
    'This payment is already being processed. Please check your order status.',
  expired:
    'This checkout session has expired. Please start a new order.',
};

function copyFor(reason: string | null): string {
  if (!reason) {
    return 'Your payment has been cancelled. Your card has not been charged.';
  }
  return (
    REASON_COPY[reason] ??
    'Your payment could not be completed. Your card has not been charged.'
  );
}

export function CancelPage(): JSX.Element {
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason');
  const requestId = searchParams.get('requestId');

  return (
    <main className="co-container">
      <div className="co-card co-center">
        <h1>Payment Cancelled</h1>
        <p className="co-muted">{copyFor(reason)}</p>
        {requestId ? (
          <p className="co-muted co-small">Request ID: {requestId}</p>
        ) : null}
      </div>
    </main>
  );
}
